import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { parseDecimal } from '../../../../../libs/utils'
import { InvestmentForm } from './types'
import { initialInvestmentModalState } from './const'

const endpointFor = (operationType: string): string => {
  if (operationType === 'lp_dividend') return '/finance/lp_dividend'
  if (operationType === 'earning') return '/finance/earning'
  return '/finance/investment'
}

const buildBody = (data: InvestmentForm) => ({
  toWallet: String(data.toWallet ?? data.walletId ?? ''),
  walletId: '',
  fromWallet: data.fromWallet,
  product: data.product,
  operationType: data.operationType,
  sentAmount: parseDecimal(data.sentAmount),
  sentCurrency: data.sentCurrency,
  receivedAmount: parseDecimal(data.receivedAmount),
  receivedCurrency: data.receivedCurrency,
  sentCommission: parseDecimal(data.sentCommission),
  sentCommissionCurrency: data.sentCommissionCurrency,
  receivedCommission: parseDecimal(data.receivedCommission),
  receivedCommissionCurrency: data.receivedCommissionCurrency,
  sentExchangeRate: parseDecimal(data.sentExchangeRate),
  receivedExchangeRate: parseDecimal(data.receivedExchangeRate),
  comment: data.comment,
  dateTime: data.dateTime,
})

export const addInvestmentMounted = createEvent<InvestmentForm>()
export const editInvestmentPaymentMounted = createEvent<InvestmentForm>()
export const deleteInvestmentPaymentMounted = createEvent<InvestmentForm>()
export const getInvestmentPaymentByIdMounted = createEvent<{ id: string }>()
export const setInvestmentForm = createEvent<InvestmentForm>()

export const $investmentForm = restore(
  setInvestmentForm,
  initialInvestmentModalState,
)

export const addInvestment = fx<ReturnType<typeof buildBody>, void>({
  method: 'POST',
  url: `/finance/investment`,
})

export const editInvestmentPayment = fx<ReturnType<typeof buildBody>, void>({
  method: 'PUT',
  url: `/finance/investment/{id}`,
})

export const getInvestmentPaymentById = fx<{ id: string }, InvestmentForm>({
  method: 'GET',
  url: `/finance/investment/{id}`,
})

export const deleteInvestmentPayment = fx<InvestmentForm, void>({
  method: 'DELETE',
  url: `/finance/investment/{id}`,
})

sample({
  clock: addInvestmentMounted,
  fn: (data) => ({
    url: endpointFor(data.operationType),
    body: buildBody(data),
  }),
  target: addInvestment,
})

sample({
  clock: editInvestmentPaymentMounted,
  fn: (data) => ({
    url: `${endpointFor(data.operationType)}/${data.id}`,
    body: buildBody(data),
  }),
  target: editInvestmentPayment,
})

sample({
  clock: deleteInvestmentPaymentMounted,
  fn: (data) => ({
    url: `${endpointFor(data.operationType)}/${data.id}`,
  }),
  target: deleteInvestmentPayment,
})

sample({
  clock: getInvestmentPaymentByIdMounted,
  fn: ({ id }) => ({ url: `/finance/investment/${id}` }),
  target: getInvestmentPaymentById,
})

sample({
  clock: getInvestmentPaymentById.doneData,
  fn: (doneData) => doneData.body,
  target: setInvestmentForm,
})
